import React from 'react';
import BreadCrumb from './components/BreadCrumb/BreadCrumb';
import Header from './components/Header/Header';
import Navigation from './components/Navigation/Navigation';
import ContentBox from './components/ContentBox/ContentBox';
import AboutKumbh from './components/AboutKumbh/AboutKumbh';
import BathingDates from './components/BathingDates/BathingDates';
import ThingsToKeepInMind from './components/ThingsToKeepInMind/ThingsToKeepInMind';
import TopRoutes from './components/TopRoutes/TopRoutes';
import WhyMMT from './components/WhyMMT/WhyMMT';
import ImportantLinks from './components/ImportantLinks/ImportantLinks';
import MapContainer from './components/MapContainer/MapContainer';
import MoreAboutPlace from './components/MoreAboutPlace/MoreAboutPlace';
import HowToReach from './components/HowToReach/HowToReach';
import WhereToStay from './components/WhereToStay/WhereToStay';
import BreadCrumbMain from '../components/BreadCrumb';
import PropTypes from 'prop-types';

import {
  breadCrumbData,
  aboutKumbhData,
  bathingDateData,
  doData,
  donotData,
  topRoutesData,
  whyMMTData,
  importantLinksData,
  moreAboutPlaceData,
  whereToStayData
} from './components/data';

import '../../styles/KumbhMelaPage.css';
import '../../styles/kumbhMelaBase.css';
import '../../styles/common.css';
import '../../styles/slick-min.css';
import '../../styles/slick-theme.css';
import HtmlHeader from '../components/HtmlHeader';
import { IRCTC_EXTERNAL_JS } from '../../utils/RailsSEOConstants';
import { getStaticPageLoadEvent } from '../../utils/omnitureUtils';

const KumbhMelaPage = ({ data }) => {
  return (
    <>
      <Navigation />
      <HtmlHeader data={data} />
      <Header>
        <BreadCrumb data={breadCrumbData} customClass="appendBottom10" />
        <BreadCrumbMain breadcrumb={data.template.breadcrumb} visible={false} />
        <h1 className="latoBold font18 whiteText">Kumbh Mela 2021</h1>
      </Header>
      <div className="container">
        <div className="contentWrapper">
          <div className="wrapper" style={{ backgroundColor: '#ffffff' }}>
            <ContentBox customClass="padding30 appendBottom30">
              <AboutKumbh data={aboutKumbhData} />
              <BathingDates data={bathingDateData} heading="Bathing Dates - January 14 to April 27, 2021" />
              <div className="keepInMind">
                <h4 className="blackText">Things to keep in mind</h4>
                <div className="keepInMind__inner">
                  <ThingsToKeepInMind data={doData} />
                  <ThingsToKeepInMind data={donotData} />
                </div>
              </div>
            </ContentBox>
            <div style={{ backgroundColor: '#ffffff' }}>
              <HowToReach
                heading="How to reach Haridwar"
                subHeading="Haridwar is well connect by all major modes of transport with almost all the cities."
              />
            </div>
            <div style={{ backgroundColor: '#ffffff' }}>
              <WhereToStay data={whereToStayData} />
            </div>
          </div>
        </div>
      </div>
      <div className="responsiveContainer">
        <MoreAboutPlace data={moreAboutPlaceData} />
        <MapContainer />
        <TopRoutes data={topRoutesData} />
        <ImportantLinks data={importantLinksData} />
        <WhyMMT data={whyMMTData} />
        {/* <Footer /> */}
      </div>
    </>
  );
};
KumbhMelaPage.propTypes = {
  data: PropTypes.object
};
KumbhMelaPage.fetchData = () => {
  const template = {
    pageUrl: `https://www.makemytrip.com/railways/kumbh-mela.html`,
    meta_title: `Kumbh Mela- Maha Kumbh mela 2021 | Book kumbh special Train, Bus, Cabs Online on Make My Trip`,
    meta_description: `Find complete information about Maha Kumbh Mela Haridwar 2021 including shahi snan. Plan your Kumbh Mela Tour Packages today with Make My Trip.`,
    meta_keywords: ``,
    analytics: getStaticPageLoadEvent('seo:rails:kumbh mela static:trains'),
    footer_data: ``,
    h1_title: `Kumbh Mela 2021`,
    breadcrumb: [
      {
        redirectionUrl: `https://www.makemytrip.com/`,
        displayString: `Home`
      },
      {
        redirectionUrl: `https://www.makemytrip.com/railways/`,
        displayString: `Rails`
      },
      {
        displayString: `Kumbh Mela 2021`,
        redirectionUrl: `https://www.makemytrip.com/railways/kumbh-mela.html`
      }
    ],
    banner_desktop: ``,
    banner_mobile: ``,
    sample_url: `https://www.makemytrip.com/railways/kumbh-mela.html`,
    // sub_title: `Following is the list of all the trains running between Delhi to Mumbai Railway Stations:`,
    // eslint-disable-next-line
    external_js: IRCTC_EXTERNAL_JS,
    extra_info: ``
  };
  // let finalResponse;

  const finalResponse = {
    template
  };
  const pageType = 'trains';
  const cacheKey = 'HTML_STATIC_KUMBH-MELA.HTML';
  return {
    pushToCache: true, // if this is set then after ssr it will be stored in cache
    cacheKey,
    pageType,
    ...finalResponse
  };
};

export default KumbhMelaPage;
